class SecureAPIClient {
    constructor() {
        this.csrfToken = null;
        this.appUrl = window.app_url || window.location.origin;
    }

    async initToken() {
        try {
            const response = await fetch(this.appUrl + '/csrf-token', {
                credentials: 'include'
            });

            const data = await response.json();
            this.csrfToken = data.token;
        } catch (error) {
            console.error('Token initialization failed', error);
        }
    }

    async makeSecureRequest(url, data, secure = true) {
        if (!secure) {
            return this._postWithoutCsrf(url, data);
        }

        if (!this.csrfToken) {
            await this.initToken();
        }

        return this._postWithCsrf(url, data);
    }

    async _postWithCsrf(url, data) {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': this.csrfToken
            },
            body: this.stringifyBigInts(data)
        });

        return this._parseResponse(response);
    }

    async _postWithoutCsrf(url, data) {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: this.stringifyBigInts(data)
        });

        return this._parseResponse(response);
    }

    async _parseResponse(response) {
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
            return await response.text();
        }
        return await response.json();
    }

    stringifyBigInts(obj) {
        return JSON.stringify(obj, (_, value) =>
            typeof value === 'bigint' ? value.toString() : value
        );
    }
}

export default SecureAPIClient;
